import { REMOVE_NOTIFICATION, ADD_NOTIFICATION, RESET_NOTIFICATIONS } from '../reducers/notifications'

const removeNotification = (id, notificationType = '') => ({
  id,
  notificationType,
  type: REMOVE_NOTIFICATION,
})

const resetNotifications = () => (dispatch) =>
  dispatch({
    type: RESET_NOTIFICATIONS,
  })

const addNotification = (notification = {}, notificationType = '') => (dispatch) =>
  dispatch({
    notification,
    notificationType,
    type: ADD_NOTIFICATION,
  })

const removeAlert = (alertId) => (dispatch) => dispatch(removeNotification(alertId, 'alert'))
const removePush = (pushId) => (dispatch) => dispatch(removeNotification(pushId, 'push'))

export default {
  removeAlert,
  removePush,
  addNotification,
  resetNotifications,
}
